import React from "react";

const NoData = () => {
  return (
    <div className="h-96 mt-5 w-full flex items-center justify-center rounded-md bg-white">
      <img className="w-60" src="/images/nodata.png" alt="" />
    </div>
  );
};

export default NoData;
